import yup from '../yup';

export const registerSchema = yup.object().shape({
  name: yup.string()
    .nullable()
    .required('Please enter your last name')
    .label('surname'),
  surname: yup.string()
    .nullable()
    .required('Please enter your first name')
    .label('name'),
  password: yup.string()
    .nullable()
    .required('Please enter a password')
    .min(8, 'Password must be at least 8 characters')
    .matches(/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]+$/, 'Password must include uppercase, lowercase, and numbers')
    .label('password'),
  passwordConfirm: yup.string()
    .nullable()
    .required('Please confirm your password')
    .oneOf([yup.ref('password')], 'Passwords do not match')
    .label('passwordConfirm'),
  hasAgreedWithTerms: yup.boolean()
    .required('Please agree to the terms of use')
    .label('hasAgreedWithTerms'),
});
